/**
 * Builds the `file_name` sent with an order payload from that order's Reference Number.
 *
 * Why: the original names of the uploaded documents are never used for storage, the database or
 * validation, but they were being joined together (e.g. "1.pdf, 2.pdf, ... 15.pdf") and sent as a
 * single `file_name`. With many documents that string overflowed the backend column and order
 * placement failed with no useful message for the client. The Reference Number is short, unique per
 * order and already part of every one of these payloads, so it is what we store instead.
 *
 * Only the value sent to the API changes — the `File` objects and the names shown in the UI are
 * left untouched, so file lists, duplicate detection and the edit/re-upload flow keep working.
 *
 * @param referenceNumber The order's Reference Number — API-generated or typed by the user.
 * @param fallbackName    Returned when no Reference Number is available, so the previous behaviour
 *                        is preserved rather than sending a bare ".pdf".
 */
export function buildOrderFileName(
  referenceNumber: any,
  fallbackName: string | null = null,
): string | null {
  const reference =
    referenceNumber === null || referenceNumber === undefined
      ? ''
      : String(referenceNumber).trim();

  if (!reference) {
    return fallbackName;
  }

  return `${reference}.pdf`;
}
